import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'
import Home from './pages/Home'
import ClosingCosts from './pages/ClosingCosts'
import DTICalculator from './pages/DTICalculator'
import MortgageCalculator from './pages/MortgageCalculator'
import TimelineCalculator from './pages/TimelineCalculator'

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/closing-costs" element={<ClosingCosts />} />
          <Route path="/dti-calculator" element={<DTICalculator />} />
          <Route path="/mortgage-calculator" element={<MortgageCalculator />} />
          <Route path="/timeline-calculator" element={<TimelineCalculator />} />
        </Routes>
      </Layout>
    </Router>
  )
}

export default App
